import { HTTP_VERBS } from "app/common/api/enums";
import { HdbParkingDO, SaveHdbParkingResponseDO } from "../domainObjects";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/v1/hdb-parking";
export class Body extends HdbParkingDO {}
export class Response extends SaveHdbParkingResponseDO {}
